import script from "./ExposicaoDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ExposicaoDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./ExposicaoDetailPage.vue?vue&type=style&index=0&id=4116c9ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4116c9ac"]])

export default __exports__